import { createFileRoute } from '@tanstack/react-router'
import { applicationSearchSchema } from '@/features/applications/filter-applications/model/applicationSearch'
import { ApplicationsPage } from '@/pages/applications/ui/ApplicationsPage'

export const Route = createFileRoute('/applications')({
  validateSearch: applicationSearchSchema,
  component: ApplicationsPage,
})
